import React, { useEffect, useRef, useState } from "react";
import emailjs from "@emailjs/browser";
import { motion } from "framer-motion";
import CloseButton from "../components/common/CloseButton";

const ContactMe = () => {
  const form = useRef();
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [show, setShow] = useState(false);

  const sendEmail = (e) => {
    e.preventDefault();
    emailjs
      .sendForm(
        "service_xb1a2w8",
        "template_ytmc9zs",
        form.current,
        "idYZbq52Om5aVJ0M8"
      )
      .then(
        (result) => {
          console.log(result.text);
          setShow(true);
          setName("");
          setEmail("");
          setMessage("");
        },
        (error) => {
          console.log(error.text);
        }
      );
  };

  useEffect(() => {
    setTimeout(function () {
      setShow(false);
    }, 3000);
  }, []);

  return (
    <motion.div
      className="h-full"
      initial={{ scale: 0, opacity: 0 }}
      animate={{ scale: 1, opacity: 1 }}
      exit={{ scale: 0, opacity: 0 }}
      transition={{ duration: 0.4 }}
    >
      <div className="bg-white dark:bg-gray-900 p-5 rounded-custom z-40">
        <div className="flex justify-between items-center">
          <h4 className="text-center font-bold text-3xl md:text-4xl text-slate-900 dark:text-white tracking-wide uppercase">
            Get in <span className="text-skin-base">touch</span>
          </h4>
          <CloseButton />
        </div>
        <div className="h-[calc(100vh-130px)] md:h-[calc(100vh-155px)] overflow-y-auto mt-4">
          <div className="flex flex-col justify-center items-center ">
            <div className="mb-8">
              <h2 className="text-center font-bold text-2xl text-slate-900 dark:text-white">
                FEEL FREE TO DROP ME A LINE
              </h2>
              <p className="text-center text-sm text-slate-500 dark:text-slate-500">
                If you have any suggestion, project or even you want to say
                Hello..
              </p>
              <p className="text-center text-sm text-slate-500 dark:text-slate-500">
                Please fill out the form below and I will reply you shortly.
              </p>
            </div>
            <div className="w-full md:w-2/3">
              <form ref={form} onSubmit={sendEmail}>
                <div className="flex flex-col mb-3">
                  <label className="text-slate-600 dark:text-slate-400 text-lg font-semibold">
                    Name
                  </label>
                  <input
                    type="text"
                    className="w-full p-2.5 text-lg rounded-custom border-2 border-slate-100 dark:border-slate-800 bg-slate-100/50 dark:bg-slate-800/50 text-slate-900 dark:text-white outline-none focus:border-2 focus:border-slate-200 dark:focus:border-slate-700"
                    placeholder="Name"
                    name="user_name"
                    value={name}
                    onChange={(e) => setName(e.preventDefault.value)}
                    required
                  />
                </div>
                <div className="flex flex-col mb-3">
                  <label className="text-slate-600 dark:text-slate-400 text-lg font-semibold">
                    Email Address
                  </label>
                  <input
                    type="email"
                    className="w-full p-2.5 text-lg rounded-custom border-2 border-slate-100 dark:border-slate-800 bg-slate-100/50 dark:bg-slate-800/50 text-slate-900 dark:text-white outline-none focus:border-2 focus:border-slate-200 dark:focus:border-slate-700"
                    placeholder="Email Address"
                    name="user_email"
                    value={email}
                    onChange={(e) => setEmail(e.preventDefault.value)}
                    required
                  />
                </div>
                <div className="flex flex-col mb-5">
                  <label className="text-slate-600 dark:text-slate-400 text-lg font-semibold">
                    Message
                  </label>
                  <textarea
                    rows="5"
                    className="w-full p-2.5 text-lg rounded-custom border-2 border-slate-100 dark:border-slate-800 bg-slate-100/50 dark:bg-slate-800/50 text-slate-900 dark:text-white outline-none focus:border-2 focus:border-slate-200 dark:focus:border-slate-700"
                    placeholder="Message"
                    name="message"
                    value={message}
                    onChange={(e) => setMessage(e.preventDefault.value)}
                    required
                  ></textarea>
                </div>
                <div className="flex justify-center mb-3">
                  <button
                    type="submit"
                    className="bg-skin-fill text-white rounded-custom px-12 py-4 text-xl uppercase hover:opacity-90 font-semibold"
                  >
                    Send Message
                  </button>
                </div>
                {show ? (
                  <div className="w-full bg-green-500/20 p-2 text-green-600 dark:text-green-500 rounded-custom font-semibold text-lg text-center">
                    Thanks For Contacting Us! We Will Get In Touch With You
                    Shortly.
                  </div>
                ) : (
                  <div></div>
                )}{" "}
              </form>
            </div>
          </div>
        </div>
      </div>
    </motion.div>
  );
};

export default ContactMe;
